export const retrieveAddressDataFromComponents = (addressComponents: google.maps.GeocoderAddressComponent[]) => {
    const result = addressComponents.reduce(
        (acc, component) => {
            if (component.types.includes('route')) {
                acc.address = component.short_name
            }
            if (component.types.includes('administrative_area_level_3')) {
                acc.city.name = component.short_name
            }
            if (component.types.includes('street_number')) {
                acc.streetNumber = component.short_name
            }
            if (component.types.includes('administrative_area_level_2')) {
                acc.province.acronym = component.short_name
                acc.provinceCode = component.short_name
            }
            if (component.types.includes('postal_code')) {
                acc.zipCode = component.short_name
            }
            if (component.types.includes('country')) {
                acc.country = component.short_name
            }
            return acc
        },
        {
            address: '',
            city: {name: '', province: {acronym: ''}},
            streetNumber: '',
            province: {acronym: ''},
            provinceCode: '',
            zipCode: '',
            country: ''
        }
    )

    return result
}
